import { type FC } from 'react';
import classes from './EmbeddedReconnectingGate.module.css';

/**
 * DL Fork: full-bleed, visually neutral gate rendered by PrivateRoute when
 * the embedded build is inside the host-app iframe and the user is
 * unauthenticated (session-auth §5.5, §6.5.1).
 *
 * Replaces `<Navigate to="/login">` so LoginLanding never mounts. The
 * host-app overlay (outside the iframe) handles the user-facing
 * "Reconnecting…" copy; this gate is just a white wash to cover any
 * pre-navigation flash.
 *
 * Intentionally has no children, no text, no spinner.
 */
const EmbeddedReconnectingGate: FC = () => {
    return (
        <div
            className={classes.gate}
            aria-hidden="true"
            data-testid="embedded-reconnecting-gate"
        />
    );
};

export default EmbeddedReconnectingGate;
